<template>
  <div class="form-group form-group--number" v-bind:class="getClass()">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label>{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <div class="input-group" v-if="component.suffix || component.prefix">
          <span class="input-group-addon" v-if="component.prefix">{{ component.prefix }}</span>
          <!--Campo desabilitado e obrigatório usa readonly, pois o vee-validate ignora campos disabled-->
          <money v-model="component.data.currentValue"
                 v-bind="format"
                 class="form-control"
                 type="text"
                 :id="component.key"
                 v-bind:name="component.key"
                 v-bind:disabled="disabledHandler() && !isRequired()"
                 v-bind:readonly="disabledHandler()"
                 v-bind:placeholder="component.placeholder"
                 v-validate="setRules()"
                 v-bind:data-vv-name="component.key"
                 v-on:focus.native="focusHandler()"
                 v-on:blur.native="blurHandler()"
                 v-on:keyup.13.native="enterHandler()"></money>
          <span class="input-group-addon" v-if="component.suffix">{{ component.suffix }}</span>
        </div>
        <!--Campo desabilitado e obrigatório usa readonly, pois o vee-validate ignora campos disabled-->
        <money v-model="component.data.currentValue"
               v-bind="format"
               class="form-control"
               type="text"
               v-bind:name="component.key"
               v-bind:disabled="disabledHandler() && !isRequired()"
               v-bind:readonly="disabledHandler()"
               v-bind:placeholder="component.placeholder"
               v-validate="setRules()"
               v-bind:data-vv-name="component.key"
               v-on:focus.native="focusHandler()"
               v-on:blur.native="blurHandler()"
               v-on:keyup.13.native="enterHandler()"
               v-else></money>
        <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g id="form_icon_error_alert" transform="translate(-252 -635)">
              <rect id="rectangle" class="cls-1" width="14" height="14" transform="translate(252 635)"/>
              <path id="ic_error_outline_24px" class="cls-2" d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z" transform="translate(251 634)"/>
            </g>
          </svg>
          {{ errorText() }}
        </span>
        <span class="help-block help-block--bottom" v-if="!errors.has(component.key) && component.description">{{ component.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'

import { Money } from '@/directives/money'

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  name: 'component-number',
  components: {
    Money
  },
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false
    }
  },
  computed: {
    format () {
      return {
        decimal: this.component.data.decimal,
        thousands: this.component.data.thousands,
        precision: this.component.data.precision,
        maxLength: 50,
        masked: false, /* doesn't work with directive */
        allowBlank: true
      }
    }
  },
  methods: {
    // Mensagem customizada do campo também no validateAll (antes só era aplicada no blur)
    errorText () {
      const isAlert = this.errors.firstByRule(this.component.key, 'alerts')
      if (!isAlert && this.component.validate.errorMessage) {
        return this.component.validate.errorMessage
      }
      return this.errors.first(this.component.key)
    }
  },
  created () {
    this.setValue()
  }
}
</script>
<style>
  .select2-container--default .select2-selection--multiple {
    background-color: #eff4fd !important;

  }
  .select2-selection__choice{
    background-color: #eff4fd !important;
  }
</style>
